import React from "react";
import { useNavigate } from "react-router-dom";
import { kastConfigs } from "../data/kastConfig";

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleKastSelection = (size: string) => {
    navigate(`/kast/${size}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Kies uw kastenmaat
        </h1>

        <div className="space-y-4">
          {Object.entries(kastConfigs).map(([key, config]) => (
            <button
              key={key}
              onClick={() => handleKastSelection(key)}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {config.label}
            </button>
          ))}
        </div>

        <div className="mt-8 text-center text-sm text-gray-600">
          <p>Selecteer de grootte van uw kast om te beginnen</p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
